var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BLOOD_TYPE_HISTORY_FORM, HistoryDisplay, HistoryDisplayUpdated, Status, } from 'shared-assets/facesheet-ui/service/facesheet/types';
import { DateTime } from 'luxon';
import rollbar from 'shared-assets/src/errors/errors';
import { formatISODateShort } from 'shared-assets/facesheet-ui/utils/patientHelper';
export var formatMedicalHistoryText = function (medicalHistory) {
    var medicalHistoryText = medicalHistory.formsName;
    if (medicalHistory.formsName === BLOOD_TYPE_HISTORY_FORM) {
        medicalHistoryText = medicalHistoryText + ": " + medicalHistory.bloodType + medicalHistory.rh;
    }
    else if (medicalHistory.comments) {
        medicalHistoryText = medicalHistoryText + ": " + medicalHistory.comments;
    }
    return medicalHistoryText;
};
export var formatSurgicalHistoryText = function (surgicalHistory) {
    var surgicalHistoryText = surgicalHistory.formsName;
    if (surgicalHistory.comments) {
        surgicalHistoryText = surgicalHistoryText + ": " + surgicalHistory.comments;
    }
    return surgicalHistoryText;
};
export var formatItemText = function (historyItem) {
    return historyItem.category + ": " + historyItem.text;
};
export var formatDeviceHistoryText = function (deviceHistory) {
    var details = deviceHistory.implantableDeviceDetails;
    var activeText = deviceHistory.active ? 'Active' : 'Inactive';
    var deviceHistoryText = 'UDI Unknown';
    if (details) {
        if (details.gmdnname && details.udi) {
            deviceHistoryText = details.gmdnname + ", " + details.udi;
        }
    }
    deviceHistoryText = deviceHistoryText + "; " + activeText;
    if (deviceHistory.comments) {
        deviceHistoryText = deviceHistoryText + " - " + deviceHistory.comments;
    }
    return deviceHistoryText;
};
var getHealthStatus = function (familyHistory) {
    var statusText = 'Unknown';
    if (familyHistory.alive === Status.YES) {
        statusText = 'Alive';
    }
    else if (familyHistory.alive === Status.NO) {
        statusText = 'Deceased';
        if (familyHistory.ageDeceased > 0) {
            statusText = statusText + " at " + familyHistory.ageDeceased;
        }
    }
    return statusText;
};
var getPlusOrMinusText = function (affectedByCondition) {
    return affectedByCondition === Status.YES ? '+' : '-';
};
var getHealthItemText = function (familyHistory) {
    var plusOrMinusText = getPlusOrMinusText(familyHistory.affectedByCondition);
    var itemText = familyHistory.formsName;
    if (familyHistory.comments) {
        itemText = itemText + " - " + familyHistory.comments;
    }
    return "" + plusOrMinusText + itemText;
};
export var getFamilyHistoryArray = function (familyHistory) {
    var history = [];
    familyHistory.forEach(function (historyItem) {
        var index = history.findIndex(function (item) { return item.displayOrder === historyItem.displayOrder; });
        if (index > -1) {
            var familyObj = history[index];
            var healthItem = getHealthItemText(historyItem);
            var updatedText = familyObj.text.concat(', ', healthItem);
            var updatedObj = __assign(__assign({}, familyObj), { text: updatedText });
            history[index] = updatedObj;
        }
        else {
            var healthStatus = getHealthStatus(historyItem);
            var healthItem = getHealthItemText(historyItem);
            var displayText = healthStatus.concat(', ', healthItem);
            history.push(new HistoryDisplay(historyItem.displayOrder, historyItem.familyRelation, displayText));
        }
    });
    return history;
};
export var getSocialHistoryArray = function (socialHistory) {
    var history = [];
    socialHistory.forEach(function (historyItem) {
        var index = history.findIndex(function (item) { return item.displayOrder === historyItem.displayOrder; });
        if (index > -1) {
            var socialObj = history[index];
            var updatedText = socialObj.text.concat(' / ', historyItem.formsName);
            if (historyItem.comments) {
                updatedText = updatedText.concat(' - ', historyItem.comments);
            }
            var updatedObj = __assign(__assign({}, socialObj), { text: updatedText });
            history[index] = updatedObj;
        }
        else {
            var displayText = historyItem.formsName || '';
            if (historyItem.comments) {
                displayText = displayText.concat(' - ', historyItem.comments);
            }
            history.push(new HistoryDisplay(historyItem.displayOrder, historyItem.category, displayText));
        }
    });
    return history;
};
export var getOBHistoryText = function (obHistory) {
    if (obHistory) {
        var displayArray_1 = [];
        if (obHistory.mensesAge > 0) {
            displayArray_1.push("Age of menses: " + obHistory.mensesAge);
        }
        if (obHistory.menopauseAge > 0) {
            displayArray_1.push("Age of menopause: " + obHistory.menopauseAge);
        }
        if (obHistory.obhistoryItems) {
            obHistory.obhistoryItems.forEach(function (item) {
                var plusOrMinusText = getPlusOrMinusText(item.affectedByCondition);
                var itemText = item.formName || '';
                if (item.comment) {
                    itemText = itemText.concat(' - ', item.comment);
                }
                displayArray_1.push(plusOrMinusText.concat(itemText));
            });
        }
        return displayArray_1.join(', ');
    }
    return '';
};
export var getPregnancyHistoryText = function (pregHistory) {
    if (pregHistory) {
        var pregnancyCount = pregHistory.numberOfPregnancy;
        var fullTermCount = pregHistory.numberOfFullTerm;
        var prematureCount = pregHistory.numberOfPremature;
        var abortionCount = pregHistory.numberOfAbortion;
        var livingCount = pregHistory.numberOfLiving;
        return "G" + pregnancyCount + " T" + fullTermCount + " P" + prematureCount + " A" + abortionCount + " L" + livingCount;
    }
    return '';
};
var getAdmissionAndDurationText = function (admission, discharge) {
    try {
        var admissionDate = DateTime.fromISO(admission, { zone: 'utc' });
        var dischargeDate = discharge
            ? DateTime.fromISO(discharge, { zone: 'utc' })
            : DateTime.local().toUTC();
        var visitLength = dischargeDate.diff(admissionDate, 'days').days;
        var displayText = admissionDate.toLocaleString() || '';
        if (visitLength) {
            displayText = displayText + " for " + Math.floor(visitLength) + " days";
        }
        return displayText;
    }
    catch (error) {
        rollbar.error(error);
        return admission;
    }
};
export var getHospitalizationText = function (visit) {
    var displayText = getAdmissionAndDurationText(visit.admissionDate, visit.dischargeDate);
    if (visit.historyDescription) {
        displayText = displayText.concat(', ', visit.historyDescription);
    }
    if (visit.status) {
        displayText = displayText.concat(', ', visit.status);
    }
    if (visit.comment) {
        displayText = displayText.concat(' - ', visit.comment);
    }
    return displayText;
};
export var getLongTermCareText = function (visit) {
    var displayText = getAdmissionAndDurationText(visit.admissionDate, visit.dischargeDate);
    if (visit.comment) {
        displayText = displayText.concat(' - ', visit.comment);
    }
    return displayText;
};
export var getHospiceText = function (visit) {
    var displayText = formatISODateShort(visit.admissionDate) || visit.admissionDate;
    if (visit.comment) {
        displayText = displayText.concat(' - ', visit.comment);
    }
    return displayText;
};
export var isPatientHistoryEmpty = function (historyData, hospitalVisits, longTermCareVisits, hospiceVisits, familyHistoryUnknown) {
    return (historyData.medicalHistory.length <= 0 &&
        historyData.surgicalHistory.length <= 0 &&
        historyData.socialHistory.length <= 0 &&
        historyData.familyHistory.length <= 0 &&
        !familyHistoryUnknown &&
        (!historyData.obPregnancyHistory ||
            (historyData.obPregnancyHistory.obhistoryItems.length <= 0 &&
                historyData.obPregnancyHistory.mensesAge <= 0 &&
                historyData.obPregnancyHistory.menopauseAge <= 0 &&
                historyData.obPregnancyHistory.numberOfPregnancy <= 0)) &&
        historyData.implantableDeviceHistory.length <= 0 &&
        hospitalVisits.length <= 0 &&
        hospiceVisits.length <= 0 &&
        longTermCareVisits.length <= 0 &&
        !historyData.historyComments.medicalHistory &&
        !historyData.historyComments.surgicalHistory &&
        !historyData.historyComments.familyHistory &&
        !historyData.historyComments.socialHistory &&
        !historyData.historyComments.obHistory &&
        !historyData.historyComments.pregnancyHistory);
};
export var isOBHistoryEmpty = function (obPregnancyHistory, historyComments) {
    return (obPregnancyHistory.mensesAge <= 0 &&
        obPregnancyHistory.menopauseAge <= 0 &&
        obPregnancyHistory.numberOfPregnancy <= 0 &&
        !historyComments.obHistory &&
        !historyComments.pregnancyHistory);
};
export var getOrderedAtText = function (lab) {
    var displayText = 'Ordered ';
    try {
        displayText = displayText + "on " + DateTime.fromMillis(lab.orderedAt).toLocaleString(DateTime.DATE_SHORT);
    }
    catch (error) {
        rollbar.error(error);
    }
    return displayText;
};
// Updated functions to support new data model returned from patient-history-service
var getHistoryItemText = function (familyMember) {
    var historyItems = familyMember.familyHistoryItems;
    var displayArray = [];
    historyItems.forEach(function (historyItem) {
        var plusOrMinusText = getPlusOrMinusText(historyItem.affectedByCondition);
        var itemText = historyItem.formsName;
        if (historyItem.comments) {
            itemText = itemText + " - " + historyItem.comments;
        }
        itemText = "" + plusOrMinusText + itemText;
        displayArray.push(itemText);
    });
    return displayArray.join(', ');
};
export var getFamilyHistoryUpdated = function (familyHistory, patientHistoryFTEnabled) {
    if (patientHistoryFTEnabled) {
        var history_1 = [];
        familyHistory.forEach(function (familyMember) {
            var healthStatus = getHealthStatus(familyMember);
            var historyItems = getHistoryItemText(familyMember);
            var displayText = healthStatus.concat(', ', historyItems);
            history_1.push(new HistoryDisplayUpdated(familyMember.id, familyMember.familyRelation, displayText));
        });
        return history_1;
    }
    else {
        return getFamilyHistoryArray(familyHistory);
    }
};
export var getSocialHistoryUpdated = function (socialHistory, patientHistoryFTEnabled) {
    if (patientHistoryFTEnabled) {
        var history_2 = [];
        socialHistory.forEach(function (historyItem) {
            var index = history_2.findIndex(function (item) { return item.category === historyItem.category; });
            if (index > -1) {
                var socialObj = history_2[index];
                var updatedText = socialObj.text.concat(' / ', historyItem.formsName);
                if (historyItem.comments) {
                    updatedText = updatedText.concat(' - ', historyItem.comments);
                }
                var updatedObj = __assign(__assign({}, socialObj), { text: updatedText });
                history_2[index] = updatedObj;
            }
            else {
                var displayText = historyItem.formsName || '';
                if (historyItem.comments) {
                    displayText = displayText.concat(' - ', historyItem.comments);
                }
                history_2.push(new HistoryDisplayUpdated(historyItem.id, historyItem.category, displayText));
            }
        });
        return history_2;
    }
    else {
        return getSocialHistoryArray(socialHistory);
    }
};
export var getOBHistoryTextUpdated = function (obHistory, patientHistoryFTEnabled) {
    if (patientHistoryFTEnabled) {
        if (obHistory) {
            var obHistoryUpdated = obHistory;
            var displayArray_2 = [];
            if (obHistoryUpdated.mensesAge > 0) {
                displayArray_2.push("Age of menses: " + obHistoryUpdated.mensesAge);
            }
            if (obHistoryUpdated.menopauseAge > 0) {
                displayArray_2.push("Age of menopause: " + obHistoryUpdated.menopauseAge);
            }
            if (obHistoryUpdated.obHistoryItems) {
                obHistoryUpdated.obHistoryItems.forEach(function (item) {
                    var plusOrMinusText = getPlusOrMinusText(item.affectedByCondition);
                    var itemText = item.formsName || '';
                    if (item.comments) {
                        itemText = itemText.concat(' - ', item.comments);
                    }
                    displayArray_2.push(plusOrMinusText.concat(itemText));
                });
            }
            return displayArray_2.join(', ');
        }
        return '';
    }
    else {
        return getOBHistoryText(obHistory);
    }
};
